import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useRef, useReducer } from 'react';
var SET_IS_VISIBLE = 'SET_IS_VISIBLE';
var SET_OPTIONS = 'SET_OPTIONS';
var initialState = {
  options: {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  },
  isVisible: false,
  wasVisible: false
};

var Reducer = function Reducer(state, action) {
  switch (action.type) {
    case SET_IS_VISIBLE:
      return Object.assign(Object.assign({}, state), {
        isVisible: action.payload || state.wasVisible,
        wasVisible: true
      });

    case SET_OPTIONS:
      return Object.assign(Object.assign({}, state), {
        options: action.payload
      });

    default:
      return state;
  }
};

export var useLazyLoad = function useLazyLoad(options) {
  var _useReducer = useReducer(Reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = useRef(null);

  var callback = function callback(entries) {
    var _entries = _slicedToArray(entries, 1),
        entry = _entries[0];

    dispatch({
      type: SET_IS_VISIBLE,
      payload: entry.isIntersecting
    });
  };

  useEffect(function () {
    if (options) {
      dispatch({
        type: SET_OPTIONS,
        payload: options
      });
    }
  }, [options]);
  useEffect(function () {
    var observer = new IntersectionObserver(callback, options);

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return function () {
      observer.disconnect();
    };
  }, [containerRef, options, state.options]);
  return Object.assign(Object.assign({}, state), {
    containerRef: containerRef
  });
};